import { FormSection, BigFormRow } from 'framework/ui/layout';
import { SuccessMessage, useMessageService } from 'framework/ui/Message';
import { ModalForm } from 'framework/form';
import useReconciliationService from 'domain/finance/costAccounting/reconcilation/useReconciliationService';
import { OfficeCodeDropdown } from 'domain/shared/employee';
import { UploadInputWithoutArtifactID } from 'domain/shared/artifact/input';
import { Box, Typography } from '@mui/material';
import { useListContext } from 'framework/list';
import { DATE_FORMAT, useDateService } from 'framework/utils';

interface UploadFileFormProps {
  closeModal: () => void;
  execute: () => void;
  modalOpen: boolean;
}

const getValidationSchema = () =>
  Promise.resolve({
    office: {
      type: 'string',
      required: true,
    },
    file: {
      type: 'array',
      required: true,
      maxSize: 1,
    },
  });

const UploadFileForm = ({ closeModal, modalOpen, execute }: UploadFileFormProps) => {
  const { addMessage } = useMessageService();
  const { uploadBankStatement } = useReconciliationService();
  const { filter } = useListContext();
  const { formatDate } = useDateService();

  return (
    <ModalForm
      closeModal={closeModal}
      modalOpen={modalOpen}
      submitFormFunc={data =>
        uploadBankStatement({ ...data, fromDate: filter?.period?.ge, toDate: filter?.period?.le })
      }
      afterSubmit={{
        execute: () => {
          addMessage(new SuccessMessage('The Bank statement has been successfully uploaded.'));
          execute();
        },
      }}
      getValidationSchemaFunc={getValidationSchema}
    >
      <Box sx={{ '& .upload-block': { minHeight: { xs: '50px', sm: '100px' } } }}>
        <FormSection>
          <Typography mb={1.25}>{`This action trigger automatic reconciliation for the current period (${formatDate(
            filter?.period?.ge,
            DATE_FORMAT.SIMPLE,
          )?.trim()} - ${formatDate(filter?.period?.le, DATE_FORMAT.SIMPLE)?.trim()}).`}</Typography>
          <BigFormRow>
            <OfficeCodeDropdown source="office" label="Office" />
          </BigFormRow>
          <BigFormRow>
            <UploadInputWithoutArtifactID
              label="Documents"
              source="file"
              canAddFromClipboard={false}
              disabled={false}
            />
          </BigFormRow>
        </FormSection>
      </Box>
    </ModalForm>
  );
};

export default UploadFileForm;
